import React from "react";
import { Utensils } from "lucide-react";

import { HoverCard } from "./ResultsPrimitives.jsx";
import { getSegmentClassName, getSegmentHoverCardAccentColor } from "../utils/fleetSegmentPresentation.js";
import { formatTimelineClockLabel } from "../utils/fleetTimelinePresentation.js";

// Bloc « Dîner » du Gantt (voir utils/lunchBreakTimeline.js), dessiné au-dessus du trajet de l'arrêt porteur,
// même protégé (z-20).
export default function LunchBreakTimelineBlock({ block, disabled = false }) {
  if (!block) {
    return null;
  }

  const blockWindow = `${formatTimelineClockLabel(block.startMinutes)} → ${formatTimelineClockLabel(block.endMinutes)}`;
  const rows = [
    ["Heure du dîner", `${formatTimelineClockLabel(block.lunchMinutes)} · fiche du chauffeur, sinon l'heure par défaut`],
    ["Bloc", blockWindow],
    ["Place", block.afterLastStop ? "Après le dernier arrêt de la journée" : "Après l'arrêt en cours à cette heure, sinon celui qui vient de finir"],
    ["Effet", `Arrêts suivants + ${block.minutes} min`],
    ["Temps travaillé", "Non compté : ni dans le total ni dans les heures max"],
    ["Réglage", "Paramètres système › Pause dîner"],
  ];

  return (
    <HoverCard
      title={`Pause dîner · ${block.minutes} min`}
      content={(
        <dl className="m-0 grid grid-cols-[auto_1fr] items-center gap-x-3 gap-y-0.5">
          {rows.map(([label, value]) => (
            <React.Fragment key={label}>
              <dt className="whitespace-nowrap font-semibold text-slate-500">{label}</dt>
              <dd className="m-0 tabular-nums text-slate-800">{value}</dd>
            </React.Fragment>
          ))}
        </dl>
      )}
      accentColor={getSegmentHoverCardAccentColor("depot_start")}
      disabled={disabled}
      delay={240}
      maxWidth={480}
      placement="top"
      referenceAsChild
    >
      <span
        role="img"
        aria-label={`Pause dîner ${block.minutes} min, ${blockWindow}`}
        data-fleet-lunch-break="true"
        className={`@container absolute top-0.5 z-[21] flex h-7.5 cursor-help items-center justify-center overflow-hidden rounded-[4px] text-[10px] font-bold leading-none ${getSegmentClassName("depot_start", false)}`}
        style={{ left: `${block.leftPercent}%`, width: `${block.widthPercent}%` }}
      >
        {/* Le mot si le bloc est assez large, sinon l'icône. */}
        <span className="hidden @min-[1.6rem]:inline">Dîner</span>
        <Utensils aria-hidden="true" className="h-3 w-3 shrink-0 @min-[1.6rem]:hidden" strokeWidth={2.4} />
      </span>
    </HoverCard>
  );
}
